import { createComponent } from '@lit/react';
import { BlocksFileUpload } from 'blocks-nextjs/blocks-web-components/components/file-upload/file-upload';
import React from 'react';
export const CatFileUpload = createComponent({
    react: React,
    tagName: 'cat-file-upload',
    elementClass: BlocksFileUpload,
    events: {
        onBlFileAdd: 'bl-file-add',
        onBlFileAction: 'bl-file-action'
    }
});
